module.exports = __webpack_public_path__ + "img/高速2.37fc2196.png";